export type TaskPriority = 'Low' | 'Medium' | 'High';

export type TaskReminder =
  | 'none'
  | 'on_due'
  | '1_day'
  | '3_day'
  | '7_day'
  | '1_day_and_due'
  | '7_day_and_due'
  | 'send_now';

export const TASK_PRIORITIES: TaskPriority[] = ['Low', 'Medium', 'High'];

export const TASK_REMINDERS: TaskReminder[] = [
  'none',
  'on_due',
  '1_day',
  '3_day',
  '7_day',
  '1_day_and_due',
  '7_day_and_due',
  'send_now',
];

export const REMINDER_LABELS: Record<TaskReminder, string> = {
  none: 'No reminder',
  on_due: 'On due date',
  '1_day': '1 day before',
  '3_day': '3 days before',
  '7_day': '7 days before',
  '1_day_and_due': '1 day before + on due',
  '7_day_and_due': '7 days before + on due',
  send_now: 'Send now (demo)',
};

export interface Task {
  matterId: string;
  taskId: string;
  organizationId: string;
  description: string;
  dueDate?: string;
  priority: TaskPriority;
  reminder: TaskReminder;
  claimRef?: string;
  completed: boolean;
  completedAt?: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  remindersSent: string[];
}

export interface CreateTaskInput {
  description: string;
  dueDate?: string;
  priority?: TaskPriority;
  reminder?: TaskReminder;
  claimRef?: string;
}

export interface UpdateTaskInput {
  description?: string;
  dueDate?: string;
  priority?: TaskPriority;
  reminder?: TaskReminder;
  claimRef?: string;
  completed?: boolean;
}
